<script>
/*  */
import { mapState } from 'vuex';
import {} from '@/scripts/utils';

export default {
  name: 'DropdownMultiple',
  components: {},
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  watch: {},
  computed: {
    ...mapState([]),
  },
  created() {},
  mounted() {},
  methods: {
    toggleSelect() {
      this.active = !this.active;
    },
    setState(id, val) {
      this.$emit('change', { [id]: val });
      /*  */
    },
  },
};
</script>

<template>
  <div class="dropdown" :class="[{ 'is-open': active, disabled: false }]">
    <!-- outside -->
    <div class="dropdown__toggle" @click="toggleSelect">
      <div
        :class="{
          dropdown__selected: true,
        }"
      >
        {{ title }}
      </div>
      <!-- arrow -->
      <img
        :src="require('@/assets/svg/triangle-yellow.svg')"
        class="dropdown__arrow"
      />
    </div>

    <!-- inside -->
    <div class="dropdown__menu">
      <div class="dropdown__content">
        <div
          class="dropdown__item"
          v-for="item in items"
          :class="{ 'is-active': false }"
          :key="item.id"
        >
          <label
            :for="`dropdown-multiple-checkbox${item.id}`"
            :class="{ checkbox: true, disabled: false }"
          >
            <input
              type="checkbox"
              :checked="item.checked"
              :id="`dropdown-multiple-checkbox${item.id}`"
              @change="e => setState(item.id, e.target.checked)"
            />
            <div class="checkbox__mark"></div>
            <div class="checkbox__title">{{ item.title }}</div>
            <div class="checkbox__subtitle">{{ item.subtitle }}</div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.dropdown {
  position: relative;

  &.is-open {
    .dropdown__menu {
      display: block;
    }
    .dropdown__arrow {
      transform: translateY(-50%) rotate(0);
    }
  }

  &__toggle {
    width: 100%;
    background: transparent;
    display: flex;
    align-items: center;
    padding: 10px 35px 10px 0;
    color: #fff;
    cursor: pointer;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
    }
  }

  &__icon {
    display: flex;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 10px;
  }

  &__arrow {
    width: 10px;
    height: 7px;
    display: flex;
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%) rotate(180deg);
    user-select: none;
  }

  &__selected {
    font-family: Poppins-Regular;
    font-size: 16px;
    line-height: 23px;
    overflow: hidden;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  &__menu {
    background: transparent;
    display: none;
  }

  &__content {
    height: auto;
    padding: 20px 0 5px;
    position: relative;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 15px 0;
  }

  &.disabled {
    .dropdown__toggle {
      pointer-events: none;
      user-select: none;
    }
    .dropdown__arrow {
      opacity: 0.5;
    }
  }
}

.checkbox {
  width: 100%;
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  &__mark {
    position: absolute;
    top: 1px;
    left: 0;
    height: 16px;
    width: 16px;
    border-radius: 4px;
    border: solid 0.9px #ffc107;
    background: transparent;
    transition: all 0.2s;

    &:after {
      content: '';
      position: absolute;
      display: none;
      left: 4px;
      top: 2px;
      width: 6px;
      height: 8px;
      border: solid #000;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  &:hover {
    .checkbox__mark {
      background-color: #ffc107;
    }
  }

  input:checked ~ .checkbox__mark:after {
    display: block;
  }

  input:checked ~ .checkbox__mark {
    background-color: #ffc107;
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;

    & + .checkbox__subtitle {
      margin-top: 10px;
    }
  }

  &__subtitle {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 1.67;
    color: rgba(255, 255, 255, 0.5);
  }

  &.disabled {
    pointer-events: none;
    user-select: none;
    opacity: 0.5;
  }
}
</style>
